import { useGlobalState, useResponsive } from '@/hooks';
import { ResponsiveCollection } from '@/interfaces';
import type { IPmtOnboardingPopup } from '@/modules/pmt/interfaces';
import Image from 'next/image';
import { ArrowUpIcon, CloseIcon, PopupContainer, StyledIconButton } from './Corner.styles';
import { PopupContent } from './PopupContent';

export const Corner: React.FC<IPmtOnboardingPopup & { onCloseOnboardingPopUp: () => void }> = ({
  heroImage,
  onCloseOnboardingPopUp,
  ...props
}) => {
  const { showPMTPopUp: isExpanded, setShowPMTPopUp: setExpanded, getProperImageUrl } = useGlobalState();
  const { isDesktopPMT } = useResponsive([ResponsiveCollection.DesktopPMT]);

  if (!isExpanded && !isDesktopPMT) return null;

  const renderIconButton = () => {
    if (isExpanded) {
      return (
        <StyledIconButton onClick={onCloseOnboardingPopUp} aria-label='Close onboarding popup'>
          <CloseIcon />
        </StyledIconButton>
      );
    }

    if (!isDesktopPMT) return null;

    return (
      <StyledIconButton onClick={() => setExpanded(true)} aria-label='Expand onboarding popup'>
        <ArrowUpIcon />
      </StyledIconButton>
    );
  };

  return (
    <PopupContainer isExpanded={isExpanded} tabIndex={0} aria-label='Onboarding popup'>
      {renderIconButton()}

      {isDesktopPMT && isExpanded && heroImage?.url && (
        <Image
          width={182}
          height={298}
          src={getProperImageUrl(heroImage)}
          alt={heroImage.title || heroImage.description || 'Banner'}
          style={{
            objectFit: 'cover',
            objectPosition: 'center',
          }}
        />
      )}

      <PopupContent isExpanded={isExpanded} {...props} />
    </PopupContainer>
  );
};
